<template>
  <div id="operation">
    <!-- 运营模式 -->
     <div class="yangshi1">
      <div class="header flex-between">
        <div class="header-text">
          <h1>会员等级消费规则设置</h1>
        </div>
        <div class="header-button">
          <el-button icon="iconfont icon-chuangjian1" @click="createTable"
            >创建</el-button
          >
          <el-button icon="el-icon-edit-outline" plain @click="saveBtn"
            >保存</el-button
          >
        </div>
      </div>
      <div class="inner" style="width: 100%">
        <el-card>
          <el-row>
            <el-col :span="22">
              <el-form ref="form" :model="formData" label-width="100px">
                <el-form-item label="订单范围">
                  <el-radio-group
                    v-model="formData.orderRange"
                    style="margin-top: 10px"
                    @change="radioChangeValue"
                  >
                    <el-row>
                      <el-radio :label="0">从注册时间开始</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio :label="1">从最近一次等级变更开始</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio :label="2">只统计最近一次等级变更后</el-radio>
                      <el-input
                        class="min"
                        style="width: 65px"
                        v-model="formData.monthLimit1"   
                      ></el-input>
                      <span
                        style="
                          width: 100px;
                          display: inline-block;
                          font-size: 14px;
                          margin-left: 3px;
                        "
                        >月的订单</span
                      >
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio :label="3">只统计最近</el-radio>
                      <el-input
                        class="min"
                        style="width: 65px"
                        v-model="formData.monthLimit2"                     
                      ></el-input>
                      <span
                        style="
                          width: 100px;
                          display: inline-block;
                          font-size: 14px;
                          margin-left: 3px;
                        "
                        >月的订单</span
                      >
                    </el-row>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="2">
              <!-- <div style="width:100%;flex-between">
                <el-button
                  class="header-button"
                  icon="el-icon-edit-outline"
                  plain
                  @click="goToOperation"
                  >管理员模式</el-button
                >
              </div> -->
            </el-col>
          </el-row>
        </el-card>
      </div>
      <!-- 组件 -->
      <consumption
        :radioValue="radioValue"
        :form="form"
        @func="getContent(index)"
        :isDisabled="isDisabled"
        ref="formRefs"
      ></consumption>
    </div>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import { ruleListApi,ruleInsert } from "@/api/user";
import consumption from "@/components/consumption/index.vue";
export default {
  name: "centre",
  components: {
    consumption,
  },
  data() {
    return {
      changeValue:"",
      comName: [], //子组件
      radioValue: null,
      formData: {},
      form: [], //子组件数据
      isDisabled: false,
      resLength: undefined,
    };
  },
  created() {
    this.lookList();
  },
  methods: {
    goToOperation() {
      this.$router.push("/GradeRule");
    },
    radioChangeValue(val) {
      this.changeValue=val
    },
    // 创建组件
    createTable() {
      this.$refs.formRefs.addLent();
    },
    // 删除组件
    getContent(index) {
      // this.comName.splice(index,1);// 删除对应的子组件
      // console.log(index,0)
      // this.$refs.formRefs[index].deleteList(index + 1);// 删除数据
      this.$refs.formRefs.deleteList(index + 1); // 删除数据
    },
    // 保存
    saveBtn() {
      // this.$refs.formRefs.createList();
      // console.log(this.onceMonth,this.radioValue);
      let monMun=''
      if(this.changeValue==2){
         monMun=this.formData.monthLimit1
      }else if(this.changeValue==3){
         monMun=this.formData.monthLimit2
      }    
       let params = {
        cpyNO: getcpyNo(),
        monthLimit:monMun,
        orderRange: this.changeValue,
      };
     let  from= this.$refs.formRefs.createList()
    //  from.yyyyy=from.yyyyy
    //  console.log('数据',from);
      ruleInsert(params, from).then((res) => {
        console.log(res);
        if (res.message == "success")
          return this.$message.success("新增数据成功!");
      });
      // console.log(this.$refs.formRefs[0].createList())
    },
    // 列表显示
    lookList() {
      ruleListApi().then((res) => {
        // console.log(res);
        if (res.success) {
          res.data.monthLimit2 = "";
          res.data.monthLimit1 = "";
          if (res.data.orderRange == 2) {
            res.data.monthLimit1 = res.data.monthLimit;
          }
          if (res.data.orderRange == 3) {
            res.data.monthLimit2 = res.data.monthLimit;
          }
          if (res.ling.length >= 0) {
            for (let i = 0; i < res.ling.length; i++) {
              res.ling[i].cardLevelText = res.ling[i].cardLevel;
              this.comName.push({
                name: "consumption",
              });
            }
          }
          this.formData = res.data;
          this.form = res.ling;
          this.resLength = res.ling.length;
          //  console.log(' this.form ', this.form );
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#operation {
  height: 100%;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
/deep/.min .el-input__inner {
  height: 20px;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
}
.el-radio {
  margin: 0;
}
</style>
